var generateStyle = function generateStyle(componentTheme) {
  return {
    alert: {
      paddingBottom: componentTheme.alertPadding,
      zIndex: componentTheme.alertZIndex,
      position: 'inherit'
    },
    alertContent: {
      display: 'block'
    },
    container: {
      position: 'relative',
      padding: componentTheme.containerPadding
    },
    disabledChildren: {
      backgroundColor: componentTheme.disabledChildrenBackgroundColor,
      opacity: componentTheme.disabledChildrenOpacity,
      position: 'absolute',
      zIndex: componentTheme.disabledChildrenZIndex,
      top: '0',
      bottom: '0',
      left: '0',
      right: '0'
    }
  };
};
export default generateStyle;